import { faSquareArrowDownRight } from "@fortawesome/pro-solid-svg-icons/faSquareArrowDownRight";
import { faSquareDashed } from "@fortawesome/pro-solid-svg-icons/faSquareDashed";
import { Grid, Stack, Typography } from '@mui/material';
import { MprcIconFa, MprcLink, MprcListItemTitle } from 'components';
import React from 'react';

export interface UnitHierarchicalItem {
    unitId: string;
    name: string;
    hasChildren: boolean;
    secondaryAction?: React.ReactNode;
    disabled?: boolean;
}

interface IProps {
    items: UnitHierarchicalItem[];
    onIconClickItem: (item: UnitHierarchicalItem) => void;
    onTitleClick: (item: UnitHierarchicalItem) => void;
    justifyLineItems?: "start" | "space-between";
    disableClickOnTitle?: boolean;
    highlightedItems?: string[];
}

export const UnitHierarchicalGridList: React.FC<IProps> = ({ items, highlightedItems, disableClickOnTitle = false, justifyLineItems = "start", onTitleClick, onIconClickItem }) => {

    return (
        <Grid container justifyContent="center" alignItems="center">
            {
                items.map((item) => {
                    return (
                        <Grid size={{ xs: 12 }} key={item.unitId} width="100%">
                            <Grid container justifyContent={justifyLineItems} alignItems="center" wrap="nowrap" width="100%">
                                <Grid>
                                    <Stack direction="row" spacing={1}>
                                        <MprcLink onClick={() => onIconClickItem(item)}>
                                            {item.hasChildren
                                                ?
                                                <MprcIconFa
                                                    icon={faSquareArrowDownRight}
                                                    color="muted"
                                                    size="lg"
                                                />
                                                :
                                                <MprcIconFa
                                                    icon={faSquareDashed}
                                                    color="muted"
                                                    size="lg"
                                                />
                                            }
                                        </MprcLink>
                                        {disableClickOnTitle
                                            ? <Typography variant="body1" color={highlightedItems?.find(p => p == item.unitId) ? "warning" : undefined}>{item.name}</Typography>
                                            : <MprcListItemTitle onClick={item.disabled ? undefined : () => onTitleClick(item)}>
                                                {item.name}
                                            </MprcListItemTitle>
                                        }
                                    </Stack>
                                </Grid>
                                <Grid marginRight={1}>
                                    {item.secondaryAction}
                                </Grid>
                            </Grid>
                        </Grid>
                    );
                })
            }
        </Grid>
    );
};
